import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteAssetGroupSaga,
  getAssetGroupDetailsSaga,
  getAssetGroupListSaga,
} from "src/store/asset-groups/saga";
import {
  AssetGroupDetailDto,
  AssetGroupDto,
} from "src/store/asset-groups/type";
import AssetGroupCreateForm from "./create";
import AssetGroupEditForm from "./edit";
const AssetGroupPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<AssetGroupDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<AssetGroupDetailDto>();
  const columns = [
    {
      text: t("AssetGroup.AssetType"),
      dataField: "AssetTypeName",
    },
    {
      text: t("AssetGroup.Name"),
      dataField: "Name",
    },
    {
      text: t("AssetGroup.Code"),
      dataField: "Code",
    },

    {
      text: t("AssetGroup.UniversalCode"),
      dataField: "UniversalCode",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("AssetGroup.PageTitle")}
        metaTag={t("AssetGroup.MetaTag")}
        gridProps={{
          addTitle: t("AssetGroup.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getAssetGroupListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getAssetGroupDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: AssetGroupDto) =>
              t("AssetGroup.DeleteQA", {
                name: data.Name,
              }),
            action: deleteAssetGroupSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <AssetGroupCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getAssetGroupListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <AssetGroupEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getAssetGroupListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default AssetGroupPage;
